import { api } from '@wellesley/openapi'
import { authSlice } from '../authSlice'
import { getStore } from '@wellesley/store'

export const handleLogin = (authToken?: string) => {
  getStore().dispatch(authSlice.actions.login(authToken))
  getStore().dispatch(api.util.invalidateTags(['Secure']))
}
